import React, { useState, useEffect } from 'react';
import api from '../api';
import './AssignSpocModal.css';

function AssignSpocModal({ mouPrefix, currentSpocs = [], onClose, onSuccess }) {
  const [allSpocs, setAllSpocs] = useState([]);
  const [selectedSpocs, setSelectedSpocs] = useState([...currentSpocs]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const res = await api.get('/api/users');
      // The users object has { managers: [...], spocs: [...], mous: {...} }
      setAllSpocs(res.data.spocs || []);
    } catch (err) {
      setError('Failed to load SPOC list.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleToggle = (email) => {
    setSelectedSpocs((prev) => {
      if (prev.includes(email)) {
        return prev.filter((e) => e !== email);
      }
      return [...prev, email];
    });
  };

  const handleSave = async () => {
    try {
      setSaving(true);
      setError(null);
      await api.patch(`/api/mous/${mouPrefix}/spoc`, { spocs: selectedSpocs });
      onSuccess(selectedSpocs);
    } catch (err) {
      setError('Failed to assign SPOCs.');
      console.error(err);
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="assign-spoc-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Assign SPOCs to {mouPrefix}</h2>
          <button className="btn-close" onClick={onClose}>&times;</button>
        </div>
        
        <div className="modal-content">
          {error && <div className="error-message">{error}</div>}
          
          {loading ? (
            <div className="loading-spinner">Loading...</div>
          ) : allSpocs.length === 0 ? (
            <p>No SPOCs found in the system. Add SPOC emails to the users configuration.</p>
          ) : (
            <div className="spoc-list">
              <p className="spoc-list-desc">Select SPOCs to manage this MoU:</p>
              {allSpocs.map((email) => (
                <label key={email} className="spoc-list-item">
                  <input
                    type="checkbox"
                    checked={selectedSpocs.includes(email)}
                    onChange={() => handleToggle(email)}
                  />
                  <span>{email}</span>
                </label>
              ))}
            </div>
          )}
        </div>

        <div className="modal-actions">
          <button className="btn-cancel" onClick={onClose} disabled={saving}>
            Cancel
          </button>
          <button className="btn-save" onClick={handleSave} disabled={saving || loading}>
            {saving ? 'Saving...' : 'Save Assignments'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default AssignSpocModal;
